import { langService } from '../network/services/lang.service';
import moment from 'moment';

const AVAILABLE_LANGS = ['FR', 'EN'];
const CURRENT_LANG = (localStorage.getItem('mih.locale') || navigator.language || navigator.userLanguage).toUpperCase();

window.dispatchEvent(new CustomEvent('app:lang', {detail: CURRENT_LANG}))


export default {
  namespaced: true,
  state: {
    loading: true,
    currentLang: AVAILABLE_LANGS.indexOf(CURRENT_LANG) !== -1 ? CURRENT_LANG : 'FR',
    languages: AVAILABLE_LANGS,

    texts: {},
  },
  mutations: {
    SET_LANG(state, payload) {
      if (state.languages.indexOf(payload) > -1) {
        state.currentLang = payload;
        localStorage.setItem('mih.locale', state.currentLang);
        moment.locale(state.currentLang);
        window.dispatchEvent(new CustomEvent('app:lang', {detail: state.currentLang}))
      }
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_TEXTS(state, payload) {
      state.texts = payload;
    },
  },
  actions: {
    async changeLang({ dispatch, commit }, payload) {
      commit('SET_LANG', payload);
      return dispatch('fetch');
    },
    async fetch({ commit }) {
      commit('SET_LOADING', true);
      const texts = await langService.getTexts();
      commit('SET_TEXTS', texts.data);
      commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/lang.store.js